import React from 'react';
import CompanyEditForm from './CompanyEditForm';
import ErrorHandler from '../../../_molecules/ErrorHandler';
import TrackPageView from '@tracking/TrackPageView';
import { SectionWrapperInner, SectionWrapperOuter } from '@styled';

const CompanyEditPage = () => {
    return (
        <ErrorHandler>
            <TrackPageView>
                <SectionWrapperOuter>
                    <SectionWrapperInner className="fade-in-fast">
                        <CompanyEditForm
                            pageTitleSub="Edit Company Profile"
                            prevNavLink="/my-icsc/account/edit-profile/education"
                            prevNavLabel="Education & Employment"
                            nextNavLink="/my-icsc/account/update-password"
                            nextNavLabel="Update Password"
                        />
                    </SectionWrapperInner>
                </SectionWrapperOuter>
            </TrackPageView>
        </ErrorHandler>
    );
};

CompanyEditPage.propTypes = {
    //
};

export default CompanyEditPage;
